import { mapGetters, mapActions } from "vuex";
import * as types from "@/store/types";
import { InitService } from "@/services";
import userService from "@/services/modules/userService";

const ManualKyc = () =>
  import(
    /* webpackChunkName: "ManualKyc" */ "@/components/AccountPage/Kyc/ManualKyc"
  );

export default {
  name: "kyc-type-selection",
  data() {
    return {
      loading: false,
      kycType: {},
      loadModal: false
    };
  },
  components: {
    ManualKyc
  },
  computed: {
    ...mapGetters({
      userVerifyInfo: types.userVerifyInfo.getters.GET_USER_VERIFY_INFO,
      userInfo: types.userInfo.getters.GET_USER_INFO
    })
  },
  mounted() {
    this.getInit();
    this.getKycType();
  },
  methods: {
    ...mapActions({
      setInit: types.init.actions.SET_INIT_DATA
    }),
    getKycType() {
      userService.getTypeOfKyc().then(res => {
        this.kycType = res.data.data;
        if (!res.data.data.methods) {
          this.$router.push("/dashboard");
          this.$toast.success(
            this.$t("accountPage.kyc.autoKyc.kycTypeSelection.disableKyc")
          );
        }
      });
    },

    getInit() {
      InitService.init().then(res => {
        this.setInit(res.data.data);
      });
    },
    openNormalVerifyModal() {
      this.loadModal = true;
      setTimeout(() => {
        this.$refs.ManualKyc.openKYCNormalModal();
      }, 300);
    },

    goKycInternationalCard(methodId) {
      this.loading = true;
      let data = {
        method_id: methodId
      };
      userService.submitKycMethodForUser(data).then(res => {
        this.loading = false;
        if (res.data.data.auto_kyc_url) {
          window.location = res.data.data.auto_kyc_url;
        } else {
          this.openNormalVerifyModal();
        }
      });

      // userService.thirdPartyKyc().then(res => {
      //   window.location = res.data.data.url;
      // });
    }
  }
};
